import createIcon from '../../createIcon';

/**
 * @component @name ContentPaste
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0gxNC44MkMxNC40IDEuODQgMTMuMyAxIDEyIDFDMTAuNyAxIDkuNiAxLjg0IDkuMTggM0g1QzMuOSAzIDMgMy45IDMgNVYyMUMzIDIyLjEgMy45IDIzIDUgMjNIMTlDMjAuMSAyMyAyMSAyMi4xIDIxIDIxVjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xMiAzQzEyLjU1IDMgMTMgMy40NSAxMyA0QzEzIDQuNTUgMTIuNTUgNSAxMiA1QzExLjQ1IDUgMTEgNC41NSAxMSA0QzExIDMuNDUgMTEuNDUgMyAxMiAzWk0xOSAyMUg1VjVIN1Y4SDE3VjVIMTlWMjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ContentPaste = createIcon('ContentPaste', [
  [
    'path',
    {
      d: 'M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V21C3 22.1 3.9 23 5 23H19C20.1 23 21 22.1 21 21V5C21 3.9 20.1 3 19 3ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM19 21H5V5H7V8H17V5H19V21Z',
      key: '15emlc',
    },
  ],
]);

export default ContentPaste;
